import {
    Box,
    Typography,
    Grid,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMSalesStatistics: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'sales': '5',
            'des': t('t108')
        },
        {
            'sales': '400',
            'des': t('t109')
        },
        {
            'sales': '100',
            'des': t('t110')
        },
        {
            'sales': '200k',
            'des': t('t111')
        }
    ]

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingTop: '60px',
                height: '285px',
                backgroundColor: '#FFFFFF',
            }}
        >
            <Box sx={{
                backgroundColor: '#0D1720',
                width: '100%',
                height: '100%',
                borderRadius: '10px',
            }}>
                <Grid container height={'100%'}>
                    {data.map((item, index) => (
                        <Grid item key={index} xs={3} alignItems={'center'} justifyContent={'center'} height={'100%'}>
                            <Box sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography fontSize={'55px'} fontWeight={600} color={'#FFFFFF'}>
                                    {data[index]['sales']}
                                    <span style={{ fontSize: '40px', color: '#FFFFFF' }}>+</span>
                                </Typography>
                                <Typography fontSize={'16px'} fontWeight={400} color={'#FFFFFF'}>
                                    {data[index]['des']}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>

        </Box>
    )
}

// ======================= EXPORT
export default SMSalesStatistics
